'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LightRight;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function LightRight(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', className: 'icon-svg-arrows-light-right ' + className, width: width, height: height, viewBox: '0 0 18 16' },
    _react2.default.createElement('path', { fill: color, d: 'M5.5 0l-1 1 7 7-7 7 1 1 8-8-8-8z' })
  );
}

LightRight.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Arrows/light/Right/Right.js
// module id = 109
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14